import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import "bootstrap/dist/css/bootstrap.css";

import CourseOfferingDisplay from "../components/CourseOfferingDisplay";

export function formatActivitySession(date, time) {
  const [start, end, timezone] = time.split(" - ").map((v) => v.trim());

  // base date
  const baseDate = moment(date).format("YYYY-MM-DD");

  // start & end datetime in timezone
  const startDateTime = moment.tz(`${baseDate} ${start}`, "YYYY-MM-DD HH:mm:ss", timezone);
  const endDateTime = moment.tz(`${baseDate} ${end}`, "YYYY-MM-DD HH:mm:ss", timezone);

  return {
    activitySession: `${startDateTime.format("ddd h:mm A")} - ${endDateTime.format("h:mm A")};`,
    startDate: startDateTime.format("DD-MMM-YYYY").toUpperCase(),
    endDate: endDateTime.format("DD-MMM-YYYY").toUpperCase(),
  };
}

const CourseOfferingActivityModal = ({ onSubmit }) => {
  const {
    course: currentCourse,
    session: currentSession,
    event: currentEvent,
  } = useSelector((state) => state.courses);

  const { activitySession, startDate, endDate } = formatActivitySession(
    currentEvent.activity_date,
    currentEvent.activity_time,
  );

  const courseDetails = {
    title: "Course Details",
    leftCol: [
      { title: "Course Name:", info: currentCourse.course_name },
      { title: "Course Number:", info: currentCourse.course_number },
      // { title: "Course Description:", info: currentCourse.course_description },
      { title: "Offering Name:", info: currentSession.offering_name },
      { title: "Offering Number:", info: currentSession.offering_number },
      // { title: "Offering Description:", info: currentSession.offering_description },
      // {
      //   title: "Offering Capacity:",
      //   info: `${currentSession.minCapacity} - ${currentSession.maxCapacity}`,
      // },
    ],
    rightCol: [
      { title: "Activity Name:", info: currentEvent.activity_name },
      { title: "Activity Number:", info: currentEvent.activity_number },
      { title: "Activity Session:", info: activitySession },
      { title: "Start Date:", info: startDate },
      { title: "End Date:", info: endDate },
      { title: "Location:", info: currentEvent.activity_venue },
    ],
    // fullCol: []
  };

  return (
    <Form onSubmit={onSubmit}>
      <CourseOfferingDisplay
        currentCourse={currentCourse}
        currentSession={currentSession}
        currentEvent={currentEvent}
        courseDetails={courseDetails}
      />
    </Form>
  );
};

export default CourseOfferingActivityModal;
